import { finalize } from 'rxjs/operators';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransportBidInfoDto, TransportBidServiceProxy, UpdateTransportBidDto } from '@shared/service-proxies/service-proxies';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';


@Component({
  selector: 'kt-test2',
  templateUrl: './test2.component.html',
  styleUrls: ['./test2.component.scss']
})
export class Test2Component implements OnInit {

  id : string ;//= "1EBB397C-2F2B-EB11-912B-005056012243" //guid NakliyeTeklif Id (Header UD degil)
  bidInfo$ : Subject<TransportBidInfoDto> = new Subject<TransportBidInfoDto>();
  formEnd$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  updateModel : UpdateTransportBidDto = new UpdateTransportBidDto();
  preValue : string = "";

  constructor(
    private _route: ActivatedRoute,
    private _trasportBidService : TransportBidServiceProxy
  ) { 
     //Tedarikci teklif entityID (querystring ile gelir)
   this.id = _route.snapshot.params.bidId ;
  }

  ngOnInit() {
    this.loadBidInfo();
}

loadBidInfo(){

  this._trasportBidService
      .getBidContent(this.id)
      .subscribe(res => {
          this.bidInfo$.next(res);

          this.updateModel.id = res.id;
      });
}

  onKeyupPhoneMask() {

  
    let newVal = this.updateModel.soforCepTelefon.replace(/\D/g, '');



    var start = this.updateModel.soforCepTelefon.length;
    if (this.updateModel.soforCepTelefon.length < this.preValue.length) {



      var lastChar: string = this.preValue.substr(this.preValue.length - 1);



      // this.message = 'Removing...'; //Just console
      /**while removing if we encounter ) character,
      then remove the last digit too.*/
      if (this.preValue.length < start) {
        if (lastChar == ")") {
          newVal = newVal.substr(0, newVal.length - 1);
        }
      }
      //if no number then flush
      if (newVal.length == 0) {
        newVal = "";
      } else if (newVal.length <= 3) {
        /**when removing, we change pattern match.
      "otherwise deleting of non-numeric characters is not recognized"*/
        newVal = newVal.replace(/^(\d{0,3})/, "($1");
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
      } else {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
      }



    }
    else {
      // don't show braces for empty value
      if (newVal.length == 0) {
        newVal = "";
      }
      // don't show braces for empty groups at the end
      else if (newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, "($1)");
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
      } else {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
      }

    }
    this.preValue = newVal;
    this.updateModel.soforCepTelefon = newVal;
  }

  onChangePhoneNumber() { }

  onSubmit(){

    

    this._trasportBidService
      .updateBidDriverInfo(this.updateModel)
      .pipe(
        finalize(() => {
          this.formEnd$.next(true);
        })
      )
      .subscribe(res => {
        //
    });
  }

}
